<p-dialog header="" [(visible)]="displayPopUp" modal="modal" minY="50">
  <p-header> Check {{ "PERSON-ON-BOARD.IN/OUT" | translate }}Details </p-header>
  <label>Latest CheckIn/CheckOut shown first</label>
  <div class="table-responsive">
    <table class="table table-bordered table-striped table-condensed">
      <thead>
        <tr>
          <th>{{ "PERSON-ON-BOARD.IN_TIME" | translate }}</th>
          <th>{{ "PERSON-ON-BOARD.IN_LOCATION" | translate }}</th>
          <th>{{ "PERSON-ON-BOARD.IN_EXACT_LOCATION" | translate }}</th>
          <th>{{ "PERSON-ON-BOARD.OUT_TIME" | translate }}</th>
          <th>{{ "PERSON-ON-BOARD.OUT_LOCATION" | translate }}</th>
          <th>{{ "PERSON-ON-BOARD.OUT_EXACT_LOCATION" | translate }}</th>
          <th>{{ "PERSON-ON-BOARD.VALID_FROM" | translate }}</th>
          <th>{{ "PERSON-ON-BOARD.EXPIRY_DATE" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let checkInCheckOutDetails of checkInCheckOutData;
            let i = index
          "
        >
          <td>
            {{
              checkInCheckOutDetails.CheckInTime
                | dateTimeFormat: "D MMM YYYY LT"
            }}
          </td>
          <td>{{ checkInCheckOutDetails["InLocationName"] }}</td>
          <td>{{ checkInCheckOutDetails.CheckInLocation }}</td>
          <td>
            {{
              checkInCheckOutDetails.CheckOutTime
                | dateTimeFormat: "D MMM YYYY LT"
            }}
          </td>
          <td>{{ checkInCheckOutDetails["OutLocationName"] }}</td>
          <td>{{ checkInCheckOutDetails.CheckOutLocation }}</td>
          <td>{{ passRequestFromDate }}</td>
          <td>{{ expiryDate }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</p-dialog>
<!--<ara-side-nav class="inside-topnav" [routesFlag]='routesFlag' [reportRoutes]='reportRoutes'></ara-side-nav>
-->
<div class="page-content-wrapper">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mobile-view">
    <ol class="breadcrumb bc-3">
      <li>
        <a [routerLink]="'/home'">Home</a>
      </li>
      <li>
        <a>Person On Board</a>
      </li>
    </ol>
    <div class="inner-wrapper">
      <!-- <div class="top-heading center">
        <h4>{{ 'PERSON-ON-BOARD.POB' | translate }} List Overview</h4>
      </div> -->
      <div class="sub-wrapper">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <!-- <li class="breadcrumb-item active" aria-current="page">POB</li> -->
            <li class="breadcrumb-item" aria-current="page">
              {{ "PERSON-ON-BOARD.POB_LIST_OVERVIEW" | translate }}
            </li>
            <li class="filter-sort" *ngIf="isOnline">
              <div class="filter-sort-wrapper">
                <a
                  class="settings"
                  data-toggle="collapse"
                  data-target="#filter"
                  (click)="onTabOpen()"
                >
                  <i
                    class="fa fa-filter"
                    aria-hidden="true"
                    pTooltip="Filter"
                    tooltipPosition="top"
                  ></i>
                </a>
                <div class="outer-wrapper" *ngIf="hideFilter">
                  <ul class="filter-section-wrapper collapse" id="filter">
                    <li>
                      <div class="leave-type">
                        <h5>{{ "PERSON-ON-BOARD.UNIT" | translate }}</h5>
                        <p-multiSelect
                          [options]="unitList"
                          [(ngModel)]="selectedUnit"
                        ></p-multiSelect>
                      </div>
                    </li>
                    <!-- <li>
                      <div class="leave-type">
                        <h5>Pass Location</h5>
                        <p-multiSelect
                          [options]="locations"
                          [(ngModel)]="selectedLocation"
                        ></p-multiSelect>
                      </div>
                    </li> -->
                    <li>
                      <div class="leave-type">
                        <h5>Check In Location</h5>
                        <p-multiSelect
                          [options]="locations"
                          [(ngModel)]="selectedCheckinLocation"
                        ></p-multiSelect>
                      </div>
                    </li>
                    <li>
                      <div class="leave-type">
                        <h5>{{ "PERSON-ON-BOARD.PASS_TYPE" | translate }}</h5>
                        <p-multiSelect
                          [options]="passTypes"
                          [(ngModel)]="selectedPassType"
                        ></p-multiSelect>
                      </div>
                    </li>
                    <div class="leave-type">
                      <div
                        class="col-lg-13 col-md-11 col-sm-11 no-padding margin-top-8"
                      >
                        <h5 class="col-lg-6">
                          {{ "PERSON-ON-BOARD.FROM_DATE" | translate }}
                        </h5>

                        <h5 class="col-lg-6">
                          {{ "PERSON-ON-BOARD.TO_DATE" | translate }}
                        </h5>

                        <div class="clearfix"></div>
                      </div>
                    </div>
                    <div class="leave-type">
                      <div
                        class="col-lg-13 col-md-11 col-sm-11 no-padding margin-top-10"
                      >
                        <p-calendar
                          [showIcon]="true"
                          [maxDate]="currentDate"
                          [showTime]="false"
                          placeholder="From"
                          dateFormat="dd/mm/yy"
                          [(ngModel)]="observationFromDate"
                          class="custom-datepicker col-lg-6"
                          readonlyInput="true"
                          required
                          #timeOfUse="ngModel"
                          monthNavigator="true"
                          yearNavigator="true"
                          yearRange="1950:2100"
                          showButtonBar="true"
                        ></p-calendar>

                        <p-calendar
                          [showIcon]="true"
                          [minDate]="observationFromDate"
                          [maxDate]="currentDate"
                          dateFormat="dd/mm/yy"
                          [showTime]="false"
                          placeholder="To"
                          [(ngModel)]="observationToDate"
                          class="custom-datepicker col-lg-6"
                          readonlyInput="true"
                          required
                          #timeOfUse="ngModel"
                          monthNavigator="true"
                          yearNavigator="true"
                          yearRange="1950:2100"
                          showButtonBar="true"
                        >
                        </p-calendar>
                        <div class="clearfix"></div>
                      </div>
                      <div class="clearfix"></div>
                    </div>

                    <li class="filter-footer">
                      <footer>
                        <a
                          (click)="resetValue(true)"
                          role="button"
                          class="btn btn-primary primary-btn button-reset"
                        >
                          <i class="fa fa-refresh"></i>reset
                        </a>
                        <a
                          (click)="doneFilter()"
                          role="button"
                          class="btn btn-primary primary-btn button-submit"
                        >
                          <i class="fa fa-check"></i>done
                        </a>
                      </footer>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="clearfix"></div>
            </li>
          </ol>
        </nav>
        <div class="section-wrapper">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
            <div
              class="col-lg-7 col-md-6 col-sm-6 col-xs-6 no-padding margin-top-10"
              *ngIf="isOnline"
            >
              <a
                [ngClass]="
                  pobListData.length && !disableExport
                    ? 'cursor-pointer'
                    : 'disabled'
                "
                (click)="
                  pobListData.length ? exportToExcel() : $event.preventDefault()
                "
                class="btn btn-primary primary-btn button-excel"
                role="button"
              >
                <i class="fa fa-file-excel-o" style="padding-right: 10px"></i>
                <ng-container *ngIf="window.innerWidth > 823"></ng-container
                >Export To Excel
              </a>
              <a
                [ngClass]="
                  pobListData.length && !disableExport
                    ? 'cursor-pointer'
                    : 'disabled'
                "
                (click)="
                  pobListData.length ? downloadZIP() : $event.preventDefault()
                "
                class="btn btn-primary primary-btn button-zip"
                role="button"
              >
                <i class="fa fa-file-zip-o" style="padding-right: 10px"></i>
                <ng-container *ngIf="window.innerWidth > 823"></ng-container
                >Export To ZIP
              </a>
            </div>
            <div
              class="col-lg-5 col-md-6 col-sm-6 col-xs-6 no-padding margin-top-10 align-right"
              *ngIf="isOnline"
            >
              <input
                type="text"
                placeholder="Search"
                class="form-control search-obs"
                [(ngModel)]="searchText"
                (keyup.enter)="searchData()"
              />
              <button class="btn btn-primary primary-btn">
                <i
                  class="fa fa-search search"
                  (click)="searchData()"
                  [class.padding]="searchText.length > 0"
                ></i>
                <i
                  class="fa fa-close clear"
                  *ngIf="searchText.length > 0"
                  (click)="clearSearch()"
                ></i>
              </button>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="clearfix"></div>
          <div class="table-responsive margin-top-15">
            <table
              class="table table-bordered table-striped table-condensed fix-tablelayout"
            >
              <thead>
                <tr>
                  <th style="width: 20px">
                    <input
                      type="checkbox"
                      [checked]="isPassRequestsChecked"
                      (change)="selectAllPassRequests($event.target.checked)"
                      [(ngModel)]="isPassRequestsChecked"
                      [value]="isPassRequestsChecked"
                    />
                  </th>
                  <th style="width: 80px">
                    {{ "PERSON-ON-BOARD.PASS_ID" | translate }}
                  </th>
                  <th style="width: 65px">Unit</th>
                  <th style="width: 60px">Pass Location</th>
                  <th style="width: 75px">Check In Location</th>               
                  <th style="width: 60px">Company</th>
                  <th style="width: 105px">
                    {{ "PERSON-ON-BOARD.FULL_NAME" | translate }}
                  </th>
                  <th style="width: 80px">Check In Date</th>
                  <th style="width: 80px">In/Out</th>
                  <th style="width: 80px">Expiry Date</th>
                  <th style="width: 80px" *ngIf="isOnline">
                    {{ "PERSON-ON-BOARD.VIEW_PASS" | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let poblist of pobListData
                      | paginate
                        : {
                            itemsPerPage: itemPerPage,
                            currentPage: pageSize,
                            totalItems: rowCount
                          }
                  "
                  id="{{ poblist.PassRequestId }}"
                  style="cursor: pointer"
                >
                  <td>
                    <input
                      type="checkbox"
                      [(ngModel)]="poblist.Checked"
                      [checked]="poblist.Checked"
                      (change)="selectPassRequests(poblist, $event)"
                      [value]="poblist"
                    />
                  </td>
                  <td (click)="showCheckInDetails(poblist)">
                    {{ poblist.PassId }}
                  </td>
                  <td (click)="showCheckInDetails(poblist)">
                    {{ poblist.UnitName }}
                  </td>
                  <td (click)="showCheckInDetails(poblist)">
                    {{ poblist.LocationName }}
                  </td>
                  <td (click)="showCheckInDetails(poblist)">
                    {{ poblist.CurrentCheckInLocation }}
                  </td>                
                  <td (click)="showCheckInDetails(poblist)">
                    {{ poblist.CompanyName }}
                  </td>
                  <td (click)="showCheckInDetails(poblist)">
                    {{ poblist.FullName }}
                  </td>
                  <td (click)="showCheckInDetails(poblist)">
                    <!-- {{
                        poblist.CheckInCheckOutDetails[0].CheckInTime
                        | dateTimeFormat: "DD/MM/YYYY"
                    }} -->
                    {{ poblist.CheckInTime }}
                  </td>
                  <td (click)="showCheckInDetails(poblist)">
                    {{ poblist.InOrOut }}
                  </td>
                  <td (click)="showCheckInDetails(poblist)">
                    <ng-container *ngIf="poblist.PassType == 'Contractor'">{{
                      poblist.PassRequestToDate
                    }}</ng-container>
                    <ng-container *ngIf="poblist.PassType == 'Staff'"
                      >NA</ng-container
                    >
                  </td>
                  <td *ngIf="isOnline">
                    <a
                      [routerLink]="[
                        '/pob/view-pass-request/',
                        poblist.PassRequestId
                      ]"
                    >
                      <i class="fa fa-eye"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
              <div
                style="width: 500px; margin-top: 15px; color: red"
                *ngIf="!showPagination"
              >
                {{ noRecordsMsg }}
              </div>
              <div style="width: 500px" *ngIf="showPagination">
                <pagination-controls
                  (pageChange)="getServerData($event)"
                ></pagination-controls>
              </div>
            </table>
          </div>
          <div class="card-view">
            <label class="checkbox-inline margin-bottom-10 pull-right"
              ><input
                type="checkbox"
                [checked]="isPassRequestsChecked"
                (change)="selectAllPassRequests($event.target.checked)"
                [(ngModel)]="isPassRequestsChecked"
                [value]="isPassRequestsChecked"
              />Select All</label
            >
            <div class="clearfix"></div>
            <div
              class="card"
              *ngFor="
                let poblist of pobListData
                  | paginate
                    : {
                        itemsPerPage: itemPerPage,
                        currentPage: pageSize,
                        totalItems: rowCount
                      }
              "
            >
              <div
                [popover]="poblist.PersonName"
                popoverTitle="Personal Name"
                popoverPlacement="bottom"
                [popoverOnHover]="false"
                [popoverCloseOnClickOutside]="true"
                [popoverCloseOnMouseOutside]="true"
                [popoverDisabled]="false"
                [popoverAnimation]="true"
                [popoverDismissTimeout]="0"
              >
                <h5 class="card-title">
                  <span class="ellepsis-mobile">{{ poblist.PersonName }}</span>
                  <span>
                    <input
                      type="checkbox"
                      [(ngModel)]="poblist.Checked"
                      [checked]="poblist.Checked"
                      (change)="selectPassRequests(poblist, $event)"
                      [value]="poblist"
                  /></span>
                </h5>
              </div>
              <p class="card-sub-title" (click)="showCheckInDetails(poblist)">
                <span>{{ poblist.PassId }}</span>
              </p>
              <p (click)="showCheckInDetails(poblist)">
                <span>{{ poblist.UnitName }}</span> -
                <span>{{ poblist.LocationName }}</span>
              </p>
              <h5 (click)="showCheckInDetails(poblist)">
                {{ poblist.InOrOut }}
              </h5>
            </div>
            <div style="margin-top: 15px; color: red" *ngIf="!showPagination">
              {{ noRecordsMsg }}
            </div>
            <div class="col-sm-12 col-xs-12" *ngIf="showPagination">
              <pagination-controls
                (pageChange)="getServerData($event)"
              ></pagination-controls>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
</div>
<ara-alerts
  [alertType]="alertType"
  [successDetails]="successDetails"
  [errorDetails]="errorDetails"
  (yesClicked)="onYesClickedForConfirmation()"
  [confirmMessage]="confirmMessage"
  (noClicked)="onNoClickedForConfirmation()"
  (okClicked)="onOkClicked()"
></ara-alerts>
